import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { PieChart } from '../../shared/charts';

import '../dashboard.scss';

const CaseSurgeonsPieChart = ({ cases = [] }) => {
  const buildSurgeonData = (cases, topN = 5) => {
    const map = {};

    cases.forEach((c) => {
      const name = c?.surgeon || 'Unknown';
      map[name] = (map[name] || 0) + 1;
    });

    const sorted = Object.entries(map)
      .sort((a, b) => b[1] - a[1])
      .slice(0, topN);

    return sorted.map(([surgeon, count]) => ({
      surgeon,
      cases: count,
    }));
  };

  const data = useMemo(() => {
    return buildSurgeonData(cases, 5).map((item) => {
      const shortName = item.surgeon
        .split(' ')
        .slice(0, 2)
        .join(' ');

      return {
        name: shortName,
        value: item.cases,
      };
    });
  }, [cases]);

  return (
    <Box className="dashboard-graph-container">
      <div className="table-title-container">
        <div className="flex-1">
          <div className="d-flex">
            <Box>
              <Box className="table-title">
                Cases
                <Box className="badge">by surgeon</Box>
              </Box>

              <Box className="table-subtitle">
                Top 5 surgeons (last 30 days)
              </Box>
            </Box>
          </div>
        </div>
      </div>

      <Box sx={{ padding: '0 24px 16px 0' }}>
        <PieChart
          data={data}
          dataKey="value"
          nameKey="name"
        />
      </Box>
    </Box>
  );
};

CaseSurgeonsPieChart.propTypes = {
  cases: PropTypes.array,
};

export default memo(CaseSurgeonsPieChart);